/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const FlowType = {
  Material: 'material',
  Energy: 'energy'
} as const;
export type FlowType = (typeof FlowType)[keyof typeof FlowType];

export function instanceOfFlowType(value: any): boolean {
  for (const key in FlowType) {
    if (Object.prototype.hasOwnProperty.call(FlowType, key)) {
      if ((FlowType as Record<string, FlowType>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FlowTypeFromJSON(json: any): FlowType {
  return FlowTypeFromJSONTyped(json, false);
}

export function FlowTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlowType {
  return json as FlowType;
}

export function FlowTypeToJSON(value?: FlowType | null): any {
  return value as any;
}
